<template>
  <b-row>
    <b-col>
      <b-row v-for="(link, index) in additionnal_links" v-bind:key="index" style="margin-bottom: 20px">
        <b-col>
          <b-form-input size="sm" v-model="link.title" placeholder="Titre"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input size="sm" v-model="link.url" placeholder="Url"></b-form-input>
        </b-col>
      </b-row>
      <b-button size="sm" @click="addLinkToList">Ajouter un lien</b-button>
    </b-col>
  </b-row>
</template>

<script>
import Axios from "axios";
export default {
  props: ["additionnal_links"],
  data() {
    return {};
  },
  methods: {
    /* Ajout de lien externe a l'épreuve */
    addLinkToList() {
      this.additionnal_links.push({ title: "", url: "" });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/component/Import/AdditionnalLinks.vue